import { render, staticRenderFns } from "./ClassifiedsListItem.vue?vue&type=template&id=1bde131b&"
import script from "./ClassifiedsListItem.vue?vue&type=script&lang=ts&"
export * from "./ClassifiedsListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports